import type { AtlasTypographySemantic } from './typography';

export type AtlasButtonTypographyRole = keyof Pick<
  AtlasTypographySemantic,
  'caption' | 'bodySmall' | 'body'
>;

export function atlasButtonTypographyKey(
  size: 'small' | 'medium' | 'large' | undefined,
): AtlasButtonTypographyRole {
  if (size === 'small') {
    return 'caption';
  }
  if (size === 'large') {
    return 'body';
  }
  return 'bodySmall';
}
